// node modules
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import {
  FelaProvider,
  HideCursorFocus,
  ThemeProvider,
} from '@upstox/upstox-ui';
// modules
import { useStore } from 'modules/Stores';
// utils
import { setBodyStyleBasedOnTheme } from './utils';

const ThemeProvider_: React.FC = ({ children }) => {
  const { theme, setTheme } = useStore('AppStore');

  const { getQuery } = useStore('RoutingStore');

  const { theme: themeQuery } = getQuery<'BASE'>();

  useEffect(() => {
    if (themeQuery && themeQuery !== theme) {
      setTheme(themeQuery, theme);
    }
    setBodyStyleBasedOnTheme(theme);
  }, [setTheme, theme, themeQuery]);

  return (
    <FelaProvider>
      <HideCursorFocus />

      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </FelaProvider>
  );
};

export default observer(ThemeProvider_);
